if (!customElements.get('anchor-button')) {
    class AnchorButton extends HTMLElement {
        constructor() {
          super();
          this.button = this.querySelector('button') ?? "";
          this.anchorToLocation = this.dataset.sectionToScroll ?? undefined;
        }
    
        connectedCallback() {
    
            if (!this.button && !this.anchorToLocation) return;
    
            console.log(this.anchorToLocation, this.button, 'ancthor stuff');
    
            this.button.addEventListener('click', () => {
                const anchorLocation = document.querySelector(`${this.anchorToLocation}`) ?? "";
                
                console.log(anchorLocation, 'loc ation');
                
                if (anchorLocation) {
                    const yVal = anchorLocation.getBoundingClientRect().top + window.scrollY - 100;
                    window.scrollTo({top: yVal, behavior: 'smooth'});
                }
            });
        }
    }
      
    customElements.define('anchor-button', AnchorButton);    
}